import { AfterViewChecked, AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-checbox',
  templateUrl: './checbox.component.html',
  styleUrls: ['./checbox.component.scss']
})
export class ChecboxComponent implements AfterViewInit {
  public data: any = {};

  @Input() set setData(v:any) {
    this.data = v;
    this.setCheckbox();
  };

  @Input() key: string;
  @Input() title: string;
  @Input() value: any = false;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  
  ngAfterViewInit(): void {
    this.setCheckbox();
  }

  setCheckbox() {
    if(this.data[this.key] && (this.data[this.key] === true || this.data[this.key] === 1)) {
      this.data[this.key] = true;
    } else {
      this.data[this.key] = null;
    }
  }

  // checked() {
  //   this.data[this.key] = !this.data[this.key];
  //   this.change.emit(this.data[this.key]);
  // }
}
